import {BleDevice} from '../protocol/ble'
import {ResultCode, WebError} from '@hybird/core/error'
import {deviceError} from '@hybird/device/deviceError'
import {DeviceEvent} from '@hybird/core/device/protocol'
import {Buffer} from 'buffer'

class WebSerialDevice extends BleDevice {
  /**
   * @type{SerialPort}
   */
  port

  /**
   * @type{BleV2Device}
   */
  codec

  /**
   * @type{Config}
   */
  config

  /**
   * @type{boolean}
   */
  _read

  constructor(config) {
    super(config.serial.name, {})
    this.config = config
  }

  async _connect({clear, resolve, reject}) {
    try {
      const ports = await navigator.serial.getPorts();

      for (const i in ports) {
        const port = ports[i];
        const info = port.getInfo();
        if (info.usbVendorId === this.config.serial.usbVendorId && info.usbProductId === this.config.serial.usbProductId) {
          this.port = port
        }
      }

      if (!this.port) {
        this.port = await navigator.serial.requestPort({
          filters: [{
            usbProductId: this.config.serial.usbProductId,
            usbVendorId: this.config.serial.usbVendorId,
          }]
        })
      }

      await this.port.open(this.config.serial)
      this._read = true
      console.log('串口info', this.port.getInfo())
      this.listenSerial()

      // 全局串口设备插入事件
      this.port.onconnect = (event) => {
        console.log('Serial connected: ', event.target)
      }

      // 全局串口设备拔出事件
      this.port.ondisconnect = (event) => {
        console.log("Serial disconnected: ", event.target);
        this.emit(DeviceEvent.DISCONNECTED);
        this._read = false;
      };

      resolve();
    } catch (e) {
      reject(WebError.error(e, deviceError.CONNECT_ERROR))
    }
  }

  async listenSerial(cancel = false) {
    const chunks = []

    const postMessage = async (chunk) => {
      chunks.push(chunk)
      const content = chunks.join('')
      console.log('serial all readable', content, content.length)
      await this._onMessage(content)
      chunks.splice(0, chunks.length)
    }

    const subMessage = async (chunk) => {
      // 新增缓冲区完整检查
      const combined = chunks.concat(chunk).join('')
      if (combined.includes('|#')) {
        chunks.splice(0, chunks.length)
        chunk = combined // 将合并后的完整数据作为新chunk处理
      }
      if (chunk.indexOf('|#') + 2 === chunk.length && chunk.endsWith('|#')) {
        await postMessage(chunk)
      } else if (chunk.includes('|#')) {
        const i = chunk.indexOf('|#')

        if (i > -1) {
          const s1 = chunk.substring(0, i + 2)
          const s2 = chunk.substring(i + 2, chunk.length)

          await postMessage(s1)
          await subMessage(s2)
        }
      } else {
        chunks.push(chunk)
      }
    }

    try {
      while (this._read) {
        const reader = await this.port.readable.getReader();

        try {
          const {value, done} = await reader.read();
          if (done) {
            // |reader| has been canceled.
            break;
          }

          await subMessage(Buffer.from(value).toString());
        } finally {
          reader.releaseLock();
        }
      }
    } catch (e) {
      console.warn("接收数据失败", e);
    }

    this._read = false
    await this.port.close()
    this.reader = null
    this.port = null
  }

  async _write({clear, buffer, resolve, reject}) {
    let writer;
    try {
      writer = this.port.writable.getWriter()
      await writer.write(buffer)

      writer.releaseLock()
      resolve()
    } catch (e) {
      writer?.releaseLock()
      reject(WebError.error(e, deviceError.WRITE_ERROR))
    }
  }

  async _onMessage(result) {
    const parseResult = this.codec.decode(result)
    await this.emitMessage(parseResult)
  }

  get state() {
    return this.connected ? 'connected' : 'disconnected'
  }

  get connected() {
    return this.port?.connected
  }

  async _disconnect() {
    if (this.reader) {
      await this.reader.cancel()
    }
  }
}

const createWebSerialDevice = {
  create: (config) => {
    return new WebSerialDevice(config)
  },
  isSupport() {
    try {
      return 'serial' in navigator
    } catch (e) {
      return false
    }
  },
  canConnect: (config, device) => {
    return config.serial.name === device.name;
  }
}

export {WebSerialDevice, createWebSerialDevice}
